"use client"
import Title from "@/components/site/Title";
import { useKeenSlider } from "keen-slider/react"
import "keen-slider/keen-slider.min.css"
import {getAssetUrl} from "@/lib/helpers/getAssetUrl";
import Link from "next/link";


export default function TrustSponsor({sponsors}){

    const [sliderRef] = useKeenSlider({
        slides: {
            perView : "auto",
            spacing : 15
        }
    });

    if(sponsors.length ===  0) return <></>

    return(
        <section className={"py-5"}>
            <Title content={"Ils nous font confiance"}/>
            <div ref={sliderRef} className={"keen-slider flex items-center justify-center pt-3"}>
                {sponsors.map(function(sponsor){
                    return(
                        <div key={sponsor} className={"keen-slider__slide flex flex-col items-center "}>
                            <a href={sponsor.url} rel={"noreferrer"} target={"_blank"}>
                                <img src={getAssetUrl(sponsor.image)} alt={sponsor.name} className={"w-32"}/>
                            </a>

                        </div>
                    )
                })}

            </div>
        </section>
    );
}